import { useFlag } from '@openfeature/react-sdk'
import Markdown from 'markdown-to-jsx'
import { Alert } from '@/ui'
import { FEATURE_FLAG_KEYS } from '@/features/open-feature'

const useMaintenanceBanner = () => {
  const maintenanceMessage = useFlag(FEATURE_FLAG_KEYS.maintenanceMessage, {
    message: null,
  })

  if (!maintenanceMessage.value.message) {
    return null
  }

  return (
    <Alert className="warning">
      <Markdown>{maintenanceMessage.value.message}</Markdown>
    </Alert>
  )
}

export const MaintenanceBanner = () => {
  const banner = useMaintenanceBanner()
  return banner
}

export const MaintenanceBannerWithBorder = () => {
  const message = useMaintenanceBanner()
  if (!message) {
    return null
  }

  return (
    <div className="border-2 border-neutral-700">
      <MaintenanceBanner />
    </div>
  )
}
